module.exports = __webpack_public_path__ + "img/cxample_07.4df96152.png";